import React, { PropsWithChildren } from "react";
import { Center, Spinner, Text } from "@chakra-ui/react";
import { HasCourseAccessOptions, hasCourseAccess, useUser } from "@utils";
import { LoginPage } from "./LoginPage";

type AccessCheckProps = PropsWithChildren<Omit<HasCourseAccessOptions, "user">>;

export function AccessCheck({
  children,
  memberships,
  isPartnerCourse,
  tiers,
  courseStatus,
}: AccessCheckProps) {
  const { user, loading, error } = useUser();

  if (loading) {
    return (
      <Center minH="100vh">
        <Spinner size="lg" />
      </Center>
    );
  }

  if (error) {
    return <div>{error.message}</div>;
  }

  if (!user) {
    return <LoginPage />;
  }

  if (courseStatus === "Coming soon") {
    return (
      <Center minH="100vh">
        <Center>
          <Text fontSize="xl">This course is not yet available.</Text>
        </Center>
      </Center>
    );
  }

  if (
    hasCourseAccess({
      user,
      memberships,
      tiers,
      isPartnerCourse,
    })
  ) {
    return <>{children}</>;
  }

  return <Center>You don&apos;t have access</Center>;
}
